import React, { useState } from 'react';
import './NumberWizardGame.css';

const NumberWizardGame: React.FC = () => {
  const [step, setStep] = useState(0);
  const [userNumber, setUserNumber] = useState<number | null>(null);
  const [isRevealed, setIsRevealed] = useState(false);
  const [calculation, setCalculation] = useState<number[]>([]);

  const steps = [
    "Think of any number",
    "Bring the same number from your friend",
    "Take from me 12",
    "Divide by half",
    "Keep one half",
    "Return your friend's number",
    "I predict you have... 6!"
  ];

  const handleNext = () => {
    if (step < steps.length - 1) {
      setStep(step + 1);
    } else {
      setIsRevealed(true);
    }
  };

  const handleRestart = () => {
    setStep(0);
    setUserNumber(null);
    setIsRevealed(false);
    setCalculation([]);
  };

  const handleNumberInput = (num: number) => {
    setUserNumber(num);
    // Calculate the steps for demonstration
    const steps = [
      num,                    // Your number
      num + num,             // Bring same number from friend (2x your number)
      num + num + 12,        // Take from me 12
      (num + num + 12) / 2,  // Divide by half
      (num + num + 12) / 2,  // Keep one half (same as above)
      (num + num + 12) / 2 - num, // Return friend's number (subtract original)
      6                      // Final result is always 6
    ];
    setCalculation(steps);
  };

  return (
    <div className="number-wizard-game">
      <div className="game-header">
        <h2>🧙‍♂️ Number Wizard</h2>
        <p>Follow my magical calculations and I'll reveal your secret number!</p>
      </div>

      <div className="game-content">
        {!isRevealed ? (
          <div className="wizard-steps">
            <div className="step-indicator">
              <span>Step {step + 1} of {steps.length}</span>
            </div>
            
            <div className="step-content">
              <div className="step-text">
                {steps[step]}
              </div>
              
              {step === 0 && (
                <div className="number-input">
                  <p>What number did you think of?</p>
                  <div className="number-input-field">
                    <input
                      type="number"
                      placeholder="Enter your number"
                      onChange={(e) => handleNumberInput(parseInt(e.target.value) || 0)}
                      className="number-input-box"
                    />
                  </div>
                  <p className="input-hint">You can use any number - positive, negative, or decimal!</p>
                </div>
              )}
              
              {step < steps.length - 1 && (
                <button className="next-btn" onClick={handleNext}>
                  {step === 0 ? 'I have my number!' : 'Next Step'}
                </button>
              )}
              
              {step === steps.length - 1 && (
                <button className="reveal-btn" onClick={handleNext}>
                  Reveal My Prediction!
                </button>
              )}
            </div>
          </div>
        ) : (
          <div className="prediction-result">
            <div className="magic-circle">
              <div className="predicted-number">6</div>
            </div>
            <h3>🎉 I predicted you have 6!</h3>
            <p>Was I right? This is the power of mathematical wizardry!</p>
            
            {userNumber !== null && calculation.length > 0 && (
              <div className="calculation-show">
                <h4>Here's the magical calculation:</h4>
                <div className="calculation-steps">
                  <p>Your number: {calculation[0]}</p>
                  <p>+ {calculation[0]} (from friend) = {calculation[1]}</p>
                  <p>+ 12 (from me) = {calculation[2]}</p>
                  <p>Divide by half = {calculation[3]}</p>
                  <p>Keep one half = {calculation[4]}</p>
                  <p>- {calculation[0]} (return to friend) = {calculation[5]}</p>
                  <p className="result">= 6 ✨</p>
                </div>
              </div>
            )}
            
            <button className="restart-btn" onClick={handleRestart}>
              Try with Another Number
            </button>
          </div>
        )}
      </div>

      <div className="game-footer">
        <p>💡 The magic: No matter what number you choose, the result is always 6!</p>
      </div>
    </div>
  );
};

export default NumberWizardGame;
